import * as z from "zod";
import type { EmailVerification } from "./email-verification";
import { emailVerificationZodObject } from "./email-verification";
import type { PhoneVerification } from "./phone-verification";
import { phoneVerificationZodObject } from "./phone-verification";

type Verification = EmailVerification | PhoneVerification;

const verificationZodObject = z.discriminatedUnion("type", [
    emailVerificationZodObject,
    phoneVerificationZodObject,
]);
const verificationZodSchema: z.ZodSchema<Verification> = verificationZodObject;

export { verificationZodSchema };
export type { Verification };
